import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { QuestionAnswer } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DialogEquipmentComponent } from 'app/main/equipments/dialog/dialog-equipments.component';
import english from '../../../../../i18n/en.json';
import spanish from '../../../../../i18n/es.json';
import portuguese from '../../../../../i18n/pt.json';

interface FormDetails {
  questionAnswers: QuestionAnswer[];
  formTitle: string;
}

@Component({
  selector: 'form-details',
  templateUrl: './form-details.component.html',
  styleUrls: ['./form-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormDetailsComponent {
  public questionAnswers: QuestionAnswer[];
  public formTitle: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FormDetails,
    public matDialogRef: MatDialogRef<DialogEquipmentComponent>,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.formTitle = data.formTitle;
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
    this.questionAnswers = data.questionAnswers;
  }

  public isChecked(answer: string, option: string): boolean {
    if (!answer) {
      return false;
    }

    const answers = answer.split('&');
    return answers.includes(option);
  }

  public splitPicturesUrl(answer: string): string[] {
    if (!answer) {
      return [];
    }

    return answer.split('&');
  }
}
